/**
 * Thumbs-up glyph used by the message-feedback row. Uses
 * `currentColor` so the enclosing `IconButton` controls tinting.
 *
 * The path data is transcribed directly from the GA-Sidekick Figma
 * source (asset hash `fcc43cdf3dde277a51b8aeee82b3e70f6a937698`). The
 * Figma artwork's native viewBox is `14.5027 x 14.8333`; it is
 * centered inside a 24x24 viewBox via a `translate(4.75, 4.5835)`
 * group so the icon matches the visual scale of the package's other
 * 24x24 glyphs (e.g. `SendArrowIcon`, `CloseGlyph`).
 */
export type ThumbsUpIconProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function ThumbsUpIcon({ size = 24, className }: ThumbsUpIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(4.75 4.5835)">
        <path
          d="M4.08333 14.0833V6.75M0.75 8.08333V12.75C0.75 13.4864 1.34695 14.0833 2.08333 14.0833H11.0342C12.0213 14.0833 12.8608 13.3631 13.0109 12.3874L13.7289 7.72078C13.9152 6.50926 12.9779 5.41667 11.7521 5.41667H9.41667C9.04848 5.41667 8.75 5.11819 8.75 4.75V2.39389C8.75 1.486 8.014 0.75 7.10611 0.75C6.88956 0.75 6.69332 0.87753 6.60537 1.07542L4.25929 6.35409C4.15229 6.59484 3.91354 6.75 3.65008 6.75H2.08333C1.34695 6.75 0.75 7.34695 0.75 8.08333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default ThumbsUpIcon;
